import React, { useState } from "react";

import {
  CloseOutlined,
  InfoCircleOutlined,
  LeftOutlined,
} from "@ant-design/icons";
import { Button, Input } from "antd";
import Modal from "antd/es/modal/Modal";

import { ReactComponent as UserFillIcon } from "../../../../../assets/images/product/user-fill.svg";

import "./ContactCsmModal.css";

export default function ContactCsmModal({
  productName,
  date,
  sampleId,
  testNames,
  loading,
  onBack,
  onCancel,
  onSubmit,
}) {
  const [comment, setComment] = useState("");
  const tests = Array.isArray(testNames) ? testNames.filter(Boolean) : [];

  return (
    <Modal
      open
      maskClosable={false}
      closable={false}
      centered
      footer={null}
      wrapClassName="ContactCsmModal"
      className="ContactCsmModal"
      width={700}
    >
      <div className="ContactCsmModal__Header">
        <div className="ContactCsmModal__HeaderLeft">
          <Button
            type="text"
            icon={<LeftOutlined />}
            className="ContactCsmModal__IconBtn"
            aria-label="Back"
            disabled={loading}
            onClick={onBack}
          />
          <span className="ContactCsmModal__Avatar" aria-hidden>
            <UserFillIcon className="ContactCsmModal__AvatarIcon" />
          </span>
          <span className="ContactCsmModal__Title">Contact CSM</span>
        </div>
        <Button
          type="text"
          icon={<CloseOutlined />}
          className="ContactCsmModal__IconBtn"
          aria-label="Close"
          disabled={loading}
          onClick={onCancel}
        />
      </div>

      <div className="ContactCsmModal__Body">
        <div className="ContactCsmModal__Alert">
          <InfoCircleOutlined className="ContactCsmModal__AlertIcon" aria-hidden />
          <p className="ContactCsmModal__AlertText">
            Provide any relevant context or questions. Our CSM will review your request and get in touch to arrange the next steps.
          </p>
        </div>

        <div className="ContactCsmModal__Details">
          <div className="ContactCsmModal__DetailRow ContactCsmModal__DetailRow--split">
            <div className="ContactCsmModal__Field">
              <span className="ContactCsmModal__Label">Product</span>
              <span className="ContactCsmModal__Value" title={productName || "-"}>
                {productName || "-"}
              </span>
            </div>
            <div className="ContactCsmModal__Field ContactCsmModal__Field--date">
              <span className="ContactCsmModal__Label">Date</span>
              <span className="ContactCsmModal__Value">{date || "-"}</span>
            </div>
          </div>

          <div className="ContactCsmModal__DetailRow">
            <span className="ContactCsmModal__Label">Sample ID</span>
            <span className="ContactCsmModal__Value ContactCsmModal__Value--sample" title={sampleId || "-"}>
              {sampleId || "-"}
            </span>
          </div>

          <div className="ContactCsmModal__DetailRow ContactCsmModal__DetailRow--tests">
            <span className="ContactCsmModal__Label">Test Names</span>
            <div className="ContactCsmModal__Chips">
              {tests.map((test) => (
                <span key={test} className="ContactCsmModal__TestChip" title={test}>
                  {test}
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="ContactCsmModal__Comments">
          <label className="ContactCsmModal__CommentsLabel" htmlFor="contact-csm-comment">
            Comments
          </label>
          <Input.TextArea
            id="contact-csm-comment"
            className="ContactCsmModal__TextArea"
            placeholder="Type"
            value={comment}
            onChange={(event) => setComment(event.target.value)}
            disabled={loading}
            maxLength={2000}
          />
        </div>
      </div>

      <div className="ContactCsmModal__Footer">
        <div className="ContactCsmModal__FooterActions">
          <Button
            type="default"
            className="ContactCsmModal__CancelBtn"
            onClick={onCancel}
            disabled={loading}
          >
            Cancel
          </Button>
          <Button
            type="primary"
            className="ContactCsmModal__SubmitBtn"
            loading={loading}
            onClick={() => onSubmit(comment.trim())}
          >
            Submit Request
          </Button>
        </div>
      </div>
    </Modal>
  );
}
